import http from './_http'

/**
 * 省市 picker 数据
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const areaLevelData = (params = {}) => {
    return http({
        url: '/area/level_data',
        method: 'get',
        params: { level: 2 }
    });
}


/**
 * 全国省市区
 * @returns {Promise | Promise<unknown>}
 */
export const areaCityData = () => {
    return http({
        url: '/area/city_data',
        method: 'get',
    });
}


/**
 * 开放城市
 * @returns {Promise | Promise<unknown>}
 */
export const areaOpenData = () => {
    return http({
        url: '/area/open_data',
        method: 'get',
    });
}

/**
 * 助理城市
 * @returns {Promise | Promise<unknown>}
 */
export const areaWaiterData = () => {
    return http({
        url: '/area/waiter_data',
        method: 'get',
    });
}

/**
 * 获取默认城市
 * @returns {Promise | Promise<unknown>}
 */
export const areaDefaultCity = (cityCode) => {
    return http({
        url: '/area/default_city',
        method: 'get',
        params: { cityCode }
    });
}
